import dayjs from "dayjs";

export enum EUserRole {
    User,
    admin
}

export class Login {
    constructor() {
        this.email = '';
        this.password = '';
    }
    email: string;
    password: string;
}

export class User {
    constructor() {
        this.id = '';
        this.name = '';
        this.role = EUserRole.User;
        this.registeredPaymentMethod = '';
        this.email = '';
        this.password = '';
        this.loginInstances = new Array<UserLoginInstance>();
        this.agentName = '';
        this.agentEmail = '';
        this.agentPhone = '';
    }
    id: string;
    name: string;
    role: EUserRole;
    registeredPaymentMethod: string;
    defaultShippingAddressId: string | undefined;
    email: string;
    password: string;
    loginInstances: Array<UserLoginInstance>;
    agentName: string;
    agentEmail: string;
    agentPhone: string;
}

export class UserLoginInstance {
    constructor() {
        this.refreshToken = '';
        this.user = new User();
        this.generatedOn = dayjs()
    }
    refreshToken: string;
    user: User;
    generatedOn: dayjs.Dayjs;
}

export class ShippingAddress {
    constructor() {
        this.id = '';
        this.externalId = '';
        this.fullAddress = '';
        this.companyName = '';
        this.address = '';
        this.users = [];
    }
    id: string;
    externalId: string;
    address: string;
    fullAddress: string;
    companyName: string;
    users: Array<User>;
}


